// Classification of account types/groups by economic role.
//
// Asset-style: more value = better → green tones.
// Debt-style:  more value = worse (you owe more) → abs'd for display.

export const DEBT_ACCOUNT_TYPES = ['credit'];
export const DEBT_GROUPS = ['Credit'];
export const DEBT_CATEGORIES = ['Debt'];

export function isDebtAccount(group, accountType) {
  if (accountType) return DEBT_ACCOUNT_TYPES.includes(accountType);
  return DEBT_GROUPS.includes(group) || DEBT_CATEGORIES.includes(group);
}

// Maps account_type → display section header.
const TYPE_TO_CATEGORY = {
  credit:     'Debt',
  checking:   'Savings',
  saving:     'Savings',
  stock:      'Investment',
  investment: 'Investment',
  funds:      'Investment',
  cash:       'Other',
  lend:       'Other',
};

// Fallback for accounts that have a group but no account_type yet.
const GROUP_TO_CATEGORY = {
  debt:       'Debt',
  savings:    'Savings',
  investment: 'Investment',
  assets:     'Other',
  other:      'Other',
  // Legacy values
  Credit:     'Debt',
  Debit:      'Savings',
  Stocks:     'Investment',
  Investment: 'Investment',
  Funds:      'Investment',
  Loan:       'Debt',
  Lend:       'Other',
};

export const CATEGORY_ORDER = ['Debt', 'Savings', 'Investment', 'Other'];

export function getDisplayCategory(account) {
  if (account.account_type) return TYPE_TO_CATEGORY[account.account_type] || 'Other';
  return GROUP_TO_CATEGORY[account.account_group] || 'Other';
}
